import React from 'react'
import { ThemeProvider } from '@mui/material/styles'
import theme from './'

const ThemeWrapper = ({ children }: React.PropsWithChildren) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}

export default ThemeWrapper
